module.exports = __webpack_public_path__ + "img/V03C.c909ac45.jpg";